export default __webpack_public_path__ + "static/media/2330.89017f89.png";